import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46ca2328"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "show-more-wrapper"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "Show more", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_double_chevrons_down_icon = _resolveComponent("double-chevrons-down-icon");
  return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default", {}, undefined, true), _withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "show-more",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
  }, [_hoisted_2, _createVNode(_component_double_chevrons_down_icon, {
    color: "var(--market-950)"
  })])], 512), [[_vShow, $options.showButton]])]);
}